import * as React from 'react'

import { IItemCard } from '../interface'

import LockupKeyFeatures from '../lockupKeyFeatures'
import LockupTagsOnMobile from '../lockupTagsOnMobile'

import CommonItemCardLayout from '../commonItemCardLayout'

const ThemeForestItemCard = (props: IItemCard) => {
  const { tags = '', term = '' } = props.locationParams
  return (
    <CommonItemCardLayout carousel {...props}>
      <LockupKeyFeatures {...props} term={term} />
      <LockupTagsOnMobile {...props} tags={tags} term={term} />
    </CommonItemCardLayout>
  )
}

export default ThemeForestItemCard
